import {EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {Component, OnInit} from '@angular/core';
import {formatDate} from '@angular/common';
import {ExcTranslation} from 'exc-core-v2';
import {ExgPopupComponent} from '../../modal/exg-popup/exg-popup.component';
import {ExgModalService} from '../../modal/exg-modal.service';
import {IExcDataDistinct} from 'exc-rest-v2';
import {IExgTableDefinition} from './IExgTableDefinition';
import {ExcCoreModule} from 'exc-core-v2';

@Component({
  selector: 'exg-table',
  templateUrl: './exg-table.component.html',
  styles: []
})
export class ExgTableComponent extends ExcTranslation implements OnInit {

  /** Table General */
  @Input() displayState = 1;
  @Input() metaInfo: any;
  @Input() distinctTableName: string | undefined;
  @Input() tableDef: IExgTableDefinition | any = [];

  @Input() allowMultiSelection = true;
  @Input() allowSingleSelection = true;
  @Input() fixedWidth = false;
  @Input() disableFilterHeader = false;
  @Input() filterHeaderFullHeight = false;

  @Input() selectSource: Array<any> = [];
  @Input() selectKey: any;

  /** Expanded Inputs */
  @Input() allowRowExpansion = false;
  @Input() expandedArray: Array<any> = [];
  @Input() expandedTemplate: any = null;

  /** Dynamic TableDef */
  @Input() dynamicTableDef = false;
  filterKey = 'value';

  /** Distinct */
  isDistinctLoading = false;
  distinctSearchValue = '';
  filteredDistinctData: any[] = [];
  private _distinctData: Array<any> = [];

  get distinctData(): Array<any> {
    return this._distinctData;
  }

  @Input() set distinctData(value: Array<any>) {
    this._distinctData = value;

    this.filteredDistinctData = value;
    this.isDistinctLoading = false;
  }

  @Input() maxDistinctRows = 25;

  currentFilterContext: string | undefined;
  currentFilterTableDef: any;
  distinctFilterActiveModel: any[] = [];
  filterPopUpOpen = false;

  /** Table Rows */
  private _rowSource: Array<any> = [];
  _selectState = false;
  _expandableState = false;

  get rowSource(): Array<any> {
    return this._rowSource;
  }

  @Input() set rowSource(value: Array<any>) {
    this._rowSource = value;
    this._selectState = false;
  }

  /** Outputs */
  @Output() RowChange: EventEmitter<number> = new EventEmitter<number>();
  @Output() ItemSelect: EventEmitter<any[]> = new EventEmitter<any[]>();
  @Output() RowDblClick: EventEmitter<number> = new EventEmitter<number>();
  @Output() FilterActivation: EventEmitter<number> = new EventEmitter<number>();
  @Output() loadDistinct: EventEmitter<IExcDataDistinct> = new EventEmitter<IExcDataDistinct>();
  @Output() selectedItems: EventEmitter<any[]> = new EventEmitter<any[]>();

  @ViewChild('Filter', {read: ExgPopupComponent}) Filter!: ExgPopupComponent;

  /** Selection Settings */
  clickRule = {prevent: false, timer: 0};

  /*_selectAllFilter = true;
  get selectAllFilter() {
    return this._selectAllFilter;
  }
  set selectAllFilter(value: boolean) {
    this._selectAllFilter = value;
  }*/

  private _selectedRow = -1;
  get selectedRow(): number {
    return this._selectedRow;
  }

  set selectedRow(value: number) {
    this.clickRule.prevent = false;
    this.clickRule.timer = setTimeout(() => {
      if (!this.clickRule.prevent) {
        this._selectedRow = value;
        this.RowChange.emit(value);
      }}, 250);
  }

  onDblClick(value: number): void {
    this.clickRule.prevent = true;
    clearTimeout(this.clickRule.timer);
    this.RowDblClick.emit(value);
  }

  constructor(private modalService: ExgModalService) {
    super();
  }

  ngOnInit(): void {
    setTimeout(() => {
      if (this.rowSource) {
        if (this.rowSource.length === this.selectSource.length) {
          this._selectState = true;
        }
      }
    }, 0);
    if (this.dynamicTableDef) { this.filterKey = 'oldID'; }
  }

  /** Row Expansion */
  isRowExpanded(index: number): boolean {
    const key = this.rowSource[index][(this.selectKey as string)];
    return this.expandedArray.indexOf(key) > -1;
  }
  doRowExpansion(value: any): void {
    this.selectedRow = value;
    if (this.allowRowExpansion && this.rowSource) {
      const key = this.rowSource[value][(this.selectKey as string)];
      const pos = this.expandedArray.indexOf(key);
      if (pos === -1) {
        this.expandedArray.push(key);
      } else {
        this.expandedArray.splice(pos, 1);
      }
    }
  }
  expandAll(value: boolean): void {
    if (this.rowSource.length === this.expandedArray.length) {
      value = false;
      this._expandableState = false;
    }
    if (this.allowRowExpansion && this.rowSource) {
      this.rowSource.forEach((element) => {
        const key = element[(this.selectKey as string)];
        const pos = this.expandedArray.indexOf(key);
        if (value === true) {
          if (pos === -1) {
            this.expandedArray.push(key);
          }
        }
        if (value === false) {
          if (pos > -1) {
            this.expandedArray.splice(pos, 1);
          }
        }
      });
    }
  }

  /** Selection */
  select(index: any, value: any): void {
    const key = this.rowSource[index][(this.selectKey as string)];
    this.doSelect(key, value);
    this.selectedItems.emit([key]);
  }

  selectClick(e: Event, index: any): void {
    e.preventDefault();
    e.stopPropagation();
    this.select(index, !this.isSelected(index));
  }

  doSelect(key: any, value: any): void {
    const pos = this.selectSource.indexOf(key);
    if (value === true) {
      if (pos === -1) {
        this.selectSource.push(key);
      }
    }
    if (value === false) {
      if (pos > -1) {
        this.selectSource.splice(pos, 1);
      }
    }
    this.ItemSelect.emit(this.selectSource);
  }

  isSelected(index: any): boolean {
    return (this.selectSource.indexOf(this.rowSource[index][(this.selectKey as string)]) > -1);
  }

  selectAll(value: boolean): void {
    this._selectState = value;
    if (this.rowSource.length === this.selectSource.length) {
      value = false;
      this._selectState = false;
    }
    const tempArray: any[] | undefined = [];
    this.rowSource.forEach((element) => {
      this.doSelect(element[(this.selectKey as string)], value);
      tempArray.push(element[(this.selectKey as string)]);
    });
    this.selectedItems.emit(tempArray);
  }

  getNestedValue(obj: any, tableDefItem: any): any {
    let properties: any[] = [];
    if (tableDefItem.hasNestedValue) {
      properties = tableDefItem.value.split('.');
    } else {
      ExcCoreModule.Array.Add(properties, tableDefItem.value);
    }
    const value = properties.reduce((acc: any, property: any) => acc[property], obj);
    if (value === null) {
      return null;
    }
    if (typeof value === 'object' && !Array.isArray(value)) {
      return Object.values(value).join(', ');
    } else if (Array.isArray(value)) {
      return value.join(', ');
    }
    return value;
  }

  /** Sort */
  ComputeSortValue(targetobj: any, source: any[]): any {
    const sval = ['', 'asc', 'desc'];
    targetobj.dataSort = {};
    source.forEach((obj) => {
      if (obj.sort > 0) {
        targetobj.dataSort[obj[this.filterKey]] = sval[obj.sort];
      }
    });
  }

  applySortValue(sortValue: number): any {
    const context = this.tableDef.find((x: any) => x[this.filterKey] === this.currentFilterContext);
    if (context.sort === sortValue) {
      context.sort = 0;
    } else {
      context.sort = sortValue;
    }
    this.ComputeSortValue(this.metaInfo, this.tableDef);
    this.FilterActivation.emit(this.metaInfo);
    this.closeFilterPopUp();
  }

  getCurrentSortValue(): any {
    if (this.currentFilterContext) {
      return this.tableDef.find((x: any) => x[this.filterKey] === this.currentFilterContext).sort;
    } else {
      return 0;
    }
  }

  getFixedTableDefCount(): any {
    return (this.tableDef.filter((x: any) => x.fixed === true && x.visible === true).length > 0);
  }

  /** Filter */
  openFilter(e: any, item: any): any {
    if (!this.disableFilterHeader) {
      this.isDistinctLoading = true;
      this.distinctSearchValue = '';
      if (this.currentFilterContext !== item[this.filterKey]) {
        this.currentFilterContext = item[this.filterKey];
        this.currentFilterTableDef = item;
      }
      this.loadDistinct.emit({tbl: this.distinctTableName, col: (this.currentFilterContext || ''), rowout: false});
      this.Filter.openUnderLeft(e);
      this.filterPopUpOpen = true;
    }
  }

  closeFilterPopUp(): void {
    this.Filter.close();
    this.filterPopUpOpen = false;
  }

  resetFilter(): void {
    this.distinctData.forEach((row) => {
      const rowID = this.currentFilterContext + row.value;
      if (this.distinctFilterActiveModel[rowID] && this.distinctFilterActiveModel[rowID] === true) {
        this.distinctFilterActiveModel[rowID] = false;
      }
    });
    (this.distinctFilterActiveModel as any)[this.currentFilterContext + `null`] = false;
    this.applyFilter();
  }

  applyFilter(): void {
    let rowCount = 0;
    let activeElementCount = 0;
    if (this.currentFilterContext === undefined) {
      return;
    }
    this.metaInfo.dataFilter[this.currentFilterContext] = [];
    // this.metaInfoDistinct.dataFilter[this.currentFilterContext] = [];
    this.filteredDistinctData.forEach((row) => {
      const rowID = this.currentFilterContext + row.value;
      if (this.distinctFilterActiveModel[rowID] && this.distinctFilterActiveModel[rowID] === true) {
        activeElementCount++;
      }
    });
    if (this.distinctSearchValue !== '' && activeElementCount === 0) {
      this.selectAllCurrentFilter(true);
    }
    this.distinctData.forEach((row) => {
      const rowID = this.currentFilterContext + row.value;
      if (this.distinctFilterActiveModel[rowID] && this.distinctFilterActiveModel[rowID] === true) {
        if (this.currentFilterContext !== undefined) {
          this.metaInfo.dataFilter[this.currentFilterContext].push(row.value);
          // this.metaInfoDistinct.dataFilter[this.currentFilterContext].push(row.value);
        }
        rowCount++;
      }
    });
    if ((this.distinctFilterActiveModel as any)[this.currentFilterContext + 'null']) {
      this.metaInfo.dataFilter[this.currentFilterContext].push('GROOT_LEERE');
      // this.metaInfoDistinct.dataFilter[this.currentFilterContext].push('GROOT_LEERE');
      rowCount++;
    }
    if (rowCount === 0) {
      this.metaInfo.dataFilter[this.currentFilterContext] = undefined;
      // this.metaInfoDistinct.dataFilter[this.currentFilterContext] = undefined;
    }
    this.FilterActivation.emit(this.metaInfo);
    this.closeFilterPopUp();
  }

  isFilterSet(value: any): boolean {
    if (this.metaInfo && this.metaInfo.dataFilter && value in this.metaInfo.dataFilter && this.metaInfo.dataFilter[value]) {
      return this.metaInfo.dataFilter[value].length > 0;
    }
    return false;
  }

  returnDistinctFilterEmptyCount(): number {
    if (this.filteredDistinctData && this.filteredDistinctData.length > 0) {
      return (this.filteredDistinctData.find(i => i?.[this.filterKey] === null)?.count || 0) +
        (this.filteredDistinctData.find(i => i?.[this.filterKey] === '')?.count || 0);
    }
    return 0;
  }

  selectAllCurrentFilter(value: any): void {
    let i = 0;
    this.filteredDistinctData.forEach(row => {
      if (i < this.maxDistinctRows) {
        this.distinctFilterActiveModel[this.currentFilterContext + row.value] = value;
      }
      i++;
    });
  }

  /** Distinct Search */
  onSearch(event: any): void {
    if (event.key === 'Enter') {
      this.isDistinctLoading = true;
      this.filteredDistinctData = [];
      if (this.currentFilterTableDef.type && this.currentFilterTableDef.type === 'date' && this.currentFilterTableDef.dateFormat) {
        this.distinctData.forEach((row) => {
          const dateValue = formatDate(new Date(row.value), this.currentFilterTableDef.dateFormat, 'de');
          if (row.value !== null && dateValue?.includes(this.distinctSearchValue) || row.value === null) {
            this.filteredDistinctData.push(row);
          }
        });
      } else {
        this.distinctData.forEach((row) => {
          if ((row.value !== null && row.value !== '' && ((this.currentFilterTableDef.transformValue !== undefined) ?
            this.currentFilterTableDef.transformValue(row.value).toLowerCase() : row.value.toLowerCase())
            .includes(this.distinctSearchValue.toLowerCase())) || row.value === null || row.value === '') {
            this.filteredDistinctData.push(row);
          }
        });
      }
      this.isDistinctLoading = false;
    }
  }

  resetSearch(): void {
    this.distinctSearchValue = '';
    this.filteredDistinctData = this.distinctData;
  }

  /** Table Type Functions */
  isDateFormat(row: any): boolean {
    return row.type && row.type === 'date' && row.dateFormat;
  }
  isCurrencyFormat(row: any): boolean {
    return row.type && row.type === 'currency' && row.currencyFormat;
  }

  /** Helper Functions */
  resetAllSorting(): void {
    this.tableDef.forEach((def: { sort: number; }) => {
      def.sort = 0;
    });
    this.metaInfo.dataSort = {};
  }

  resetAllFiltering(): void {
    this.distinctFilterActiveModel = [];
    this.metaInfo.dataFilter = {};
  }

  resetMultiSelection(): void {
    this.selectSource = [];
  }

  resetListContext(): void {
    this.resetMultiSelection();
    this.resetAllSorting();
    this.resetAllFiltering();
  }

}
